// src/app/services/seo.service.ts
import { Injectable, Inject } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { Title, Meta } from "@angular/platform-browser";

export interface SeoConfig {
  title?: string;
  description?: string;
  canonicalUrl?: string;
}

@Injectable({
  providedIn: "root",
})
export class SeoService {
  constructor(
    private titleService: Title,
    private metaService: Meta,
    @Inject(DOCUMENT) private dom: Document
  ) {}

  setSeoData(config: SeoConfig): void {
    // Handle Title
    if (config.title) {
      this.setTitle(config.title);
    } else {
      this.removeTitle(); // Remove title if not present
    }

    // Handle Description
    if (config.description) {
      this.setDescription(config.description);
    } else {
      this.removeDescription(); // Remove description if not present
    }

    // Handle Canonical URL
    if (config.canonicalUrl) {
      this.setCanonicalURL(config.canonicalUrl);
    } else {
      this.removeCanonicalURL(); // Remove canonical URL if not present
    }
  }

  setTitle(title: string): void {
    const titleTag = document.querySelector("title");
    if (titleTag) {
      titleTag.innerText = title;
    } else {
      const newTitleTag = document.createElement("title");
      newTitleTag.innerText = title;
      document.head.appendChild(newTitleTag);
    }
  }

  removeTitle(): void {
    const titleTag = document.querySelector("title");
    if (titleTag) {
      document.head.removeChild(titleTag);
    }
  }

  setDescription(description: string): void {
    let descriptionTag = document.querySelector('meta[name="description"]');
    if (!descriptionTag) {
      descriptionTag = document.createElement("meta");
      descriptionTag.setAttribute("name", "description");
      document.head.appendChild(descriptionTag);
    }
    descriptionTag.setAttribute("content", description);
  }

  removeDescription(): void {
    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      document.head.removeChild(descriptionTag);
    }
  }

  setCanonicalURL(url: string): void {
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    if (!canonicalTag) {
      canonicalTag = document.createElement("link");
      canonicalTag.setAttribute("rel", "canonical");
      document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", url);
  }

  removeCanonicalURL(): void {
    const canonicalTag = document.querySelector('link[rel="canonical"]');
    if (canonicalTag) {
      document.head.removeChild(canonicalTag);
    }
  }
}
